import React from 'react';
import './App.css'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoginForm from './frontend/LoginForm';
import ProfilePage from './frontend/ProfilePage';
import SalesPage from './frontend/SalesPage';
import UserAccessPage from './frontend/UserAccessPage';
import TeamSales from './frontend/TeamSales';
import PartnersSales from './frontend/PartnersSales';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginForm />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/sales-dashboard" element={<SalesPage />} />
        <Route path="/team-dashboard" element={<TeamSales />} />
        <Route path="/partners-dashboard" element={<PartnersSales/>} />
        <Route path="/login" element={<LoginForm />} />
        <Route path="/user-access" element={<UserAccessPage />} />
      </Routes>
    </Router>
  );
};

export default App;
